import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation, ViewChild } from "@angular/core";
import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { Subject, takeUntil } from "rxjs";
import { Router } from "@angular/router";
import { ChartBuilderProvider } from "app/providers/chartBuilder.provider";
import { ConstantProvider } from "app/providers/constant.provider";
import { UserService } from "app/core/user/user.service";
import { SettingService } from "app/modules/admin/setting/service/setting.service";
import { HomeService } from "../../services/home.service";
import { home, missions, podium, prizes, trivias, upcomingAnniversaries, upcomingBirthdays } from "../../services/home.type";
import { MissionsService } from 'app/modules/normal/missions/services/missions.service';
import moment from "moment";

@Component({
  selector: 'home-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: fuseAnimations
})

export class DashboardComponent {

  public customer: string = '';
  public welcome_message: string = '';
  public progress: number = 0;
  public level_img: string = '';
  public level_name: string = '';
  public total_points: number = 0;

  private unsubscribeAll: Subject<any> = new Subject<any>();

  // Pruebas
  public upcomingBirthdays: upcomingBirthdays[]
//   = [
//     {
//       id: 1,
//       avatar: 'https://plug-erwp-media.fra1.digitaloceanspaces.com/local/games/cG9kaXVt.png',
//       name: 'Mario',
//       last_name: 'Pereira',
//       date: '2023-05-18',
//     },
//     {
//       id: 2,
//       avatar: 'https://plug-erwp-media.fra1.digitaloceanspaces.com/local/games/RXhwZXJ0YV90cml2aWFz.png',
//       name: 'christian josue',
//       last_name: 'martinez hinojosa ',
//       date: '2000-05-20',
//     },
//     {
//       id: 3,
//       avatar: 'https://plug-erwp-media.fra1.digitaloceanspaces.com/local/users_avatars/TWFsZV9hdmF0YXI.png',
//       name: 'Fer',
//       last_name: 'Nara',
//       date: '2010-05-28',
//     }
//   ]

  public upcomingAnniversaries: upcomingAnniversaries[]
//   = [
//     {
//       id: 1,
//       avatar: 'https://plug-erwp-media.fra1.digitaloceanspaces.com/local/games/cG9kaXVt.png',
//       name: 'christian josue',
//       last_name: 'martinez hinojosa ',
//       date: '2023-05-18',
//     },
//     {
//       id: 2,
//       avatar: 'https://plug-erwp-media.fra1.digitaloceanspaces.com/local/games/RXhwZXJ0YV90cml2aWFz.png',
//       name: 'Daniel',
//       last_name: 'Serrano',
//       date: '2000-05-20',
//     },
//     {
//       id: 2,
//       avatar: 'https://plug-erwp-media.fra1.digitaloceanspaces.com/local/users_avatars/TWFsZV9hdmF0YXI.png',
//       name: 'Fer',
//       last_name: 'Nara',
//       date: '2010-05-28',
//     }
//   ]

  public podium: podium[]
//   = [
//     {
//       id: 2,
//       podium_index: 2,
//       avatar: 'https://plug-erwp-media.fra1.digitaloceanspaces.com/local/games/cG9kaXVt.png',
//       name: 'Mario',
//       last_name: 'Pereiraaaaaaaaaaaaaa',
//       points: 3000000000000,
//     },
//     {
//       id: 2,
//       podium_index: 2,
//       avatar: 'https://plug-erwp-media.fra1.digitaloceanspaces.com/local/games/RXhwZXJ0YV90cml2aWFz.png',
//       name: 'Daniel',
//       last_name: 'Serrano',
//       points: 2500000000,
//     },
//     {
//       id: 2,
//       podium_index: 2,
//       avatar: 'https://plug-erwp-media.fra1.digitaloceanspaces.com/local/users_avatars/TWFsZV9hdmF0YXI.png',
//       name: 'Fer',
//       last_name: 'Nara',
//       points: 2450000000000,
//     }
//   ]

  public missions: missions /* =
    {
      victory_percentage: 29.6,
      won_total: 5,
      assigned_total: 12,
      lost_total: 12,
      in_revision_total: 3,
    } */

  public prizes: prizes /* =
    {
      rewards_ready: 12,
      redeemed_points: 250,
    } */

  public trivias: trivias /* =
    {
      victory_percentage: 29.6,
      won_total: 5,
      loss_total: 5,
      pending_total: 5,
      rematch_total: 5,
    } */

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _fuseConfirmationService: FuseConfirmationService,
    private router: Router,
    private chart: ChartBuilderProvider,
    public constants: ConstantProvider,
    public userloguedservice: UserService,
    private settinService: SettingService,
    private homeservices: HomeService,
    private missionServices: MissionsService
  ) {

  }

  ngOnInit(): void {
    this.getHome();
    // this.getWordCoin();
  }

  ngAfterViewInit(): void {
    this.getHome();
  }

  // getWordCoin() : void {
  //   this.settinService.setting$.pipe(takeUntil(this.unsubscribeAll)).subscribe( (res) => {
  //     this.word_coin=res.word_coin;
  //   });
  // }

  getHome(): void {

    this.homeservices.detail()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(
        (res) => {
          this.customer = 'Hola ' + res.customer;
          this.welcome_message = res.welcome_message;
          this.progress = res.progress;
          this.level_img = res.level_img;
          this.level_name = res.level_name;
          this.total_points = res.total_points;
          this.upcomingBirthdays = res.upcoming_birthdays;
          this.upcomingAnniversaries = res.upcoming_anniversaries;
          this.podium = res.podium;
          this.missions = res.missions;
          this.trivias = res.trivias;
          this.prizes = res.prizes;

          this._changeDetectorRef.detectChanges();
        }
      )
  }

  getDate(fecha_convertir: string, format: string = 'DD/MM/YY hh:mm'): string {
    let fecha: string = moment(fecha_convertir).locale('es').format(format).toString();
    return fecha;
  }

  mergeText(array_Text: string[]): string {
    let merged_text: string = '';
    for (let i = 0; i < array_Text.length; i++) {
        merged_text += array_Text[i].toLowerCase() + ' ';
    }
    return merged_text;
  }

  formatString(text: string | number, num_caracter: number): string {
    let return_text: string = text.toString();
    if (return_text.length > num_caracter) {
        return return_text.substring(0, num_caracter) + '...';
    } else {
        return return_text;
    }
  }

}
